/*
    Email Broadcasts
*/
export const TEST_EMAIL_SENT = 'Test email sent';
export const EMAIL_BROADCAST_RESCHEDULED = 'Email Broadcast Rescheduled';
export const START_EMAIL_BROADCAST = 'Start Email Broadcast';
export const BROADCAST_CREATED = 'Broadcast Created';
export const BROADCAST_SENT = 'Broadcast Sent';
export const BROADCAST_CREATE_A_TEMPLATE = 'Create a template';
export const BROADCAST_TEXT_ONLY = 'Text only';
export const BROADCAST_SELECT_TEMPLATE = 'Select template';
export const SET_UP_EMAIL_DOMAIN = 'Set up email domain';
export const ADD_EMAIL_DOMAIN = 'Add email domain';
export const AUTHENTICATE_EMAIL_DOMAIN = 'Authenticate email domain';

/*
    Campaign Emails
 */
export const CAMPAIGN_BROADCAST_UNLAYER_SAVED_ITEM = 'Campaigns - Unlayer Saved item - success: Item marked as ready';

/*
    Comms
*/
export const MARKETING_NUMBER_PROVISIONED = 'Text Marketing Number Provisioned';
export const TEXT_BEGIN_MARKETING_NUMBER_PROVISIONING = 'Text Marketing Provisioning Started';
export const TEXT_COMPLETE_MARKETING_NUMBER_PROVISIONING = 'Text Marketing Number Provisioned';
export const TEXT_MARKETING_DISCOVERED = 'Text Marketing Discovered';
export const TEXT_MARKETING_AUTOMATION_CREATED = 'Added Text Automation';
export const TEXT_MARKETING_AUTOMATION_PRICING_ALERT_CLOSED = 'Closed pricing alert';
export const KMN_TEMPLATE_CHOSEN = 'KMN Template Chosen';
export const KMN_TEMPLATE_CREATED = 'KMN Template Created';
export const KMN_TEMPLATE_DELETED = 'KMN Template Deleted';
export const MANAGE_KMN_TEMPLATES = 'Manage KMN Templates';
export const TEXT_BROADCAST_CREATED = 'Text Broadcast Created';
export const TEXT_BROADCAST_WRITTEN = 'Text Broadcast Written';
export const TEXT_BROADCAST_SENT = 'Text Broadcast Sent';
export const KMN_BROADCAST_LIMIT_EXCEEDED = 'KMN Broadcast limit exceeded';
export const TOGGLED_CONTACT_RECORD = 'toggled contact record layout';

/*
    Support
*/

export const SUBMIT_CALLBACK = 'Submitted phone support call back';
export const CHAT_STARTED = 'Started chat with support';

/* Contacts */
export const CONTACT_LIMIT_ALERT = 'Contact limit alert';

/* Marketing Sites */
export const MARKETING_SITE_SHARE_FEEDBACK_DISMISSED = 'Landing Pages Feedback modal dismissed';

/* Subscription Management */
export const SUBSCRIPTION_MANAGEMENT_QUICK_ADD = 'Subscription Management Quick Add';
export const PRO_SERVICES = 'Pro Services';
